import { type ComponentProps, type ReactElement } from 'react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { SUPPORT_READONLY_TOOLTIP } from '@/components/alertActionTooltipCopy';

/**
 * A Security Groups write control (KIR-5086). Viewers who cannot write (support
 * — the route already keeps members out) see it grayed out with the read-only
 * tooltip instead of not at all: "disable, don't hide".
 */
export function WriteGatedButton({
  canEdit,
  disabled,
  ...props
}: ComponentProps<typeof Button> & { canEdit: boolean }): ReactElement {
  if (canEdit) return <Button disabled={disabled} {...props} />;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* A disabled <button> fires no pointer events; the span carries the hover. */}
        <span tabIndex={0} className="inline-flex">
          <Button {...props} disabled onClick={undefined} />
        </span>
      </TooltipTrigger>
      <TooltipContent>{SUPPORT_READONLY_TOOLTIP}</TooltipContent>
    </Tooltip>
  );
}
